<template>
  <div class="checkbox">
    <input
      ref="inputbox"
      type="checkbox"
      :disabled="disabled"
      :checked="checked"
      @change="$emit('change', $event.target.checked)">
    <span class="checkbox__tick" aria-hidden="true" v-if="checked"></span>
    <span
      class="label"
      v-if="label">
        {{label}}
      </span>
  </div>
</template>

<script>
  export default {
    name: 'WCheckbox',
    model: {
      prop: 'checked',
      event: 'change',
    },
    props: {
      checked: {
        type: Boolean,
        required: false,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      label: String,
      checkedColor: String,
    },
    mounted() {
      if (this.checkedColor) {
        this.$refs.inputbox.style.backgroundColor = this.checkedColor;
        this.$refs.inputbox.style.borderColor = this.checkedColor;
      }
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../assets/styles/variables";

  .checkbox {
    width: 20px;
    height: 20px;

    input[type=checkbox] {
      align-items: center;
      appearance: none;
      cursor: pointer;

      width: 20px;
      height: 20px;
      border: 1px solid $primary-main;
      box-sizing: border-box;
      border-radius: 4px;
      outline: none;

      &:checked {
        background-color: $primary-main;
        /*
         * FIXME: for some reason referencing svg resources with url() doesn't work
         */
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='13' viewBox='0 0 14 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 6.21739L5.28571 11L13 1' stroke='white' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E%0A");
        background-repeat: no-repeat;
        background-size: 80%;
        background-position: center center;
      }
    }
  }
  .disabled {
    input[type=checkbox] {
      cursor: not-allowed !important;
    }
  }
  .activePlatform {
    input[type=checkbox] {
      border: 1px solid $platform;
      &:checked {
        background-color: $platform;
      }
    }
  }
</style>
